import { ReactNode } from 'react';
import { SxProps, Theme, Typography } from '@mui/material';
import { spreadSx } from 'ui-kit/lib/utils/spreadSx';

export const H1 = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SxProps<Theme>;
}) => (
  <Typography
    sx={[
      {
        lineHeight: { xs: '24px', sm: '36px', lg: '42px' },
        typography: { xs: '20_24_700', sm: '24_34_700', lg: '32_40_700' },
      },
      ...spreadSx(sx),
    ]}
    component={'h1'}
  >
    {children}
  </Typography>
);
